import type { Meta, StoryFn } from '@storybook/react';
import type { TooltipProps } from './Tooltip';

import { Tooltip } from './Tooltip';

import { Container } from 'storyComponents/Container';

const codeString = '<Tooltip element={element} id={id} text={text} size={size} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Tooltip',
  component: Tooltip,
  argTypes: {
    element: {
      control: 'text',
    },
    // Disable openUnderTrigger controls as this is a Lens specific prop that we should not use in other places.
    // This is still needed until Lens structure is reworked.
    openUnderTrigger: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Tooltip,
    codeString: codeString,
  },
} as Meta<TooltipProps>;

const Template: StoryFn<TooltipProps> = (args) => (
  <Container centerContent>
    <Tooltip {...args} />
  </Container>
);

export const TooltipExample = Template.bind({});
TooltipExample.args = {
  element: 'Tooltip Trigger',
  id: '52fcc9e9',
  text: 'Here is your Tooltip',
};
